import { render, staticRenderFns } from "./FolderListHeader.vue?vue&type=template&id=9833a19c&scoped=true&"
import script from "./FolderListHeader.vue?vue&type=script&lang=js&"
export * from "./FolderListHeader.vue?vue&type=script&lang=js&"
import style0 from "./FolderListHeader.vue?vue&type=style&index=0&id=9833a19c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9833a19c",
  null
  
)

export default component.exports